import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const locale = 'en'

const messages = {
  en: {
    "address_street_1": "Address line 1",
    "address_street_2": "Address line 2",
    "address_zip": "Postal code",
    "address_city": "City",
    "address_country": "Country",
    "book": "Book",
    "birth_year": "Birth year",
    "birth_month": "Birth month",
    "birth_day": "Birth day",
    "close": "Close",
    "cancel": "Cancel",
    "confirm_password": "Confirm Password",
    "current_password": "Current Password",
    "email": "Email",
    "error_alert_title": "Oops...",
    "error_alert_text": "Something went wrong! Please try again.",
    "emergency_contact": "Emergency contact",
    "forgot_password": "Forgot Your Password?",
    "food_medical_comment": "Food & medical information",
    "go_home": "Go Home",
    "home": "Home",
    "info_name_address": "Name and address",
    "info_skills": "Skills",
    "info_physical": "Physical info",
    "info_updated": "Your info has been updated!",
    "info_update_failed": "Failed to save..",
    "info_insurance":"Insurance information",
    "insurance_company":"Insurance company",
    "insurance_number":"Insurance number",
    "invoice_currency": "Invoice currency",
    "login": "Log In",
    "logout": "Logout",
    "name": "Name",
    "name_company": "Company name",
    "name_first": "First name",
    "name_last": "Last name",
    "nav_menu_title": "Application Menu",
    "new_password": "New Password",
    "ok": "Ok",
    "page_not_found": "Page Not Found",
    "password": "Password",
    "password_updated": "Your password has been updated!",
    "password_length_hint": "At least 8 characters",
    "personal_info": "Personal information",
    "phone": "Phone",
    "phone_number": "Phone number",
    "profile": "Profile",
    "register": "Register",
    "remember_me": "Remember Me",
    "reset_password": "Reset Password",
    "set_password": "Set Password",
    "registration_welcome":"Welcome!",
    "registration_header":"To complete your accout registration, enter a password below.",
    "save":"Save",
    "send_password_reset_link": "Send Password Reset Link",
    "send_booking_request": "Send booking request",
    "settings": "Settings",
    "shoe_size": "Shoe size",
    "skills_technical": "Technical skills",
    "skills_fitness": "Fitness level",
    "skills_comment": "Other skills",
    "toggle_navigation": "Toggle navigation",
    "token_expired_alert_title": "Session Expired!",
    "token_expired_alert_text": "Please log in again to continue.",
    "update": "Update",
    "weight": "Weight",
    "height": "Height",
    "you_are_logged_in": "You are logged in!",
    "your_password": "Your Password",
    "your_bookings": "Your bookings",
    "company_org_no": "VAT number/Organisationsnummer",
    "invoices": "Invoices",
    "unpaid_invoices": "Unpaid invoices"
  }
}

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/plugins/vue-i18n.js